export const PROMOTION_DEALER_INFO_ICON_SIZE = 16;
